<div class="panel">
    <h1 class="title">{{ 'lock.title' | translate }}</h1>
    <p class="subtitle">{{ 'lock.subtitle' | translate }}</p>
    <app-form-pin [formField]="pinForm.pin" [label]="'auth.pin.prompt' | translate" inputId="lock-pin" />
</div>
